import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import CheckValidateRoute from "./CheckValidateRoute";
import JobDetails from "views/job-details/JobDetails";

// import from "tailwindcss"

class App extends Component {
  async componentDidMount() {}
  render() {
    return (
      <Switch>
        <Route
          path={`${process.env.PUBLIC_URL}/`}
          exact
          component={JobDetails}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/:param`}
          component={CheckValidateRoute}
        />
      </Switch>
    );
  }
}

export default App;
